<template>
  <div class="app-wrapper app-wrapper--menu-top">
    <!-- 头部 -->
    <div
      class="e6-header-section"
      :class="{ 'is-scroll': urlPath }"
      v-show="!isFullScreen"
    >
      <div class="e6-menu-section">
        <!-- <base-menu mode="horizontal" :collapse="false" menuTrigger="hover" /> -->
        <BaseHeader :collapse.sync="isCollapse">
          <template v-slot:navbar>
            <base-menu
              mode="horizontal"
              :collapse="false"
              menuTrigger="hover"
            />
          </template>
        </BaseHeader>
      </div>
    </div>
    <!-- 头部 end -->
    <section
      class="e6-container-section"
      :class="[
        { full: isFullScreen },
        { 'is-scroll': urlPath && !isFullScreen }
      ]"
    >
      <main class="e6-main-section">
        <transition name="fade-transform" mode="out-in">
          <router-view />
        </transition>
      </main>
    </section>
  </div>
</template>

<script>
import baseMenu from "../components/menu";
import BaseHeader from "./baseHeader/index";
import { mapGetters } from "vuex";

export default {
  components: {
    baseMenu,
    BaseHeader
  },
  data() {
    return {
      isCollapse: false
    };
  },

  computed: {
    ...mapGetters(["isFullScreen"]),
    urlPath() {
      if (this.$route.path === "/home") {
        return true;
      } else {
        return false;
      }
    }
  }
};
</script>
<style lang="scss" scoped>
$--header-height: 60px;
$--navbar-bgolor: #3594ff;
.app-wrapper {
  height: 100vh;
  .e6-header-section {
    height: $--header-height;
    &.is-scroll {
      position: fixed;
      left: 0;
      right: 0;
      z-index: 9999;
    }
    .e6-menu-section {
      transition: width 0.5s ease;
      overflow: hidden;
      height: 100%;
      // background: linear-gradient(to right, #006fec, #3e43f4);
      background-color: #2157f0;
      /deep/ .e6-nav-menu__scroll {
        height: 100%;
        .el-scrollbar__wrap {
          overflow: hidden;
          .el-scrollbar__view {
            .el-menu {
              .is-active {
                border-bottom: none;
                background-color: $--navbar-bgolor !important;
                color: #ffffff !important;
              }
              .el-menu-item {
                &:hover {
                  background-color: $--navbar-bgolor !important;
                }
              }
              .el-submenu {
                &.is-active {
                  .el-submenu__title {
                    background-color: $--navbar-bgolor !important;
                  }
                }
                .el-submenu__title {
                  &:hover {
                    background-color: $--navbar-bgolor !important;
                  }
                  color: #ffffff !important;
                  .el-submenu__icon-arrow {
                    color: #ffffff;
                  }
                }
                .el-menu--horizontal {
                  background-color: #df4646 !important;
                  .el-menu {
                    background-color: #df4646 !important;
                    .el-menu-item {
                      background-color: #b10e0e !important;
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  .e6-container-section {
    position: relative;
    height: calc(100vh - 60px);
    background-color: #edf1f6;
    &.is-scroll {
      top: 60px;
      width: 1920px;
      min-height: 860px;
      overflow: auto;
    }

    &.full {
      height: 100vh;
    }
    .e6-main-section {
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      overflow: hidden;
    }
  }
}
</style>
